/**
 * CoSingery — **「我的」頁嘅意見回饋卡**（`decisions/043`）
 *
 * 為何抽元件：`MePage` 已經超硬規則 B（逐檔 ≤200 行）→ **唔准再加**落去；
 *   呢張卡（標題＋一句提示＋〔畀啲意見〕掣＋彈窗）自成一體，父層只需要放一個標籤。
 *
 * ⚠️ 提交結果一律照實顯示（成功／失敗／上限）—— 唔准扮成功。
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FeedbackSheet from './FeedbackSheet';

export default function MeFeedbackCard({
  locale,
  appVersion,
  cardStyle,
  headingStyle,
  buttonStyle,
}: {
  locale: string;
  appVersion?: string;
  cardStyle: React.CSSProperties;
  headingStyle: React.CSSProperties;
  buttonStyle: React.CSSProperties;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <section style={cardStyle} data-testid="me-feedback">
      <h2 style={headingStyle}>{t('feedback_title')}</h2>
      <p className="footnote" style={{ margin: '0 0 8px' }}>
        {t('me_feedback_hint')}
      </p>
      <button type="button" data-testid="me-feedback-open" onClick={() => setOpen(true)} style={buttonStyle}>
        {t('me_feedback_button')}
      </button>
      <FeedbackSheet
        open={open}
        onClose={() => setOpen(false)}
        locale={locale}
        page="me"
        {...(appVersion ? { appVersion } : {})}
      />
    </section>
  );
}
